function initWarrantySlider() {
  const $slider = jQuery('.warranty-slider-wrap .slick-slider');

  if (!$slider.length) return;

  if ($slider.hasClass('slick-initialized')) {
    $slider.slick('unslick');
  }

  let windowWidth = window.innerWidth;

  $slider.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    centerMode: true,
    centerPadding: windowWidth >= 1440 && windowWidth <= 2000 ? '210px' : '50px',
    arrows: false,
    dots: true,
    adaptiveHeight: false,
    autoplay: true,
    autoplaySpeed: 5000,
    speed: 600,
    cssEase: 'ease-out'
  });

  // FORCE recalculation (critical)
  $slider.slick('setPosition');
}

/* Normal page load */
jQuery(document).ready(function () {
  initWarrantySlider();
});

/* Shopify section reload support */
document.addEventListener('shopify:section:load', function () {
  initWarrantySlider();
});

/* Window resize fix */
window.addEventListener('resize', function () {
  clearTimeout(window._slickResizeTimer);
  window._slickResizeTimer = setTimeout(initWarrantySlider, 300);
});


// document.addEventListener('DOMContentLoaded', function () {
//     if (typeof jQuery !== 'undefined' && jQuery.fn.slick) {

//         const $slider = jQuery('.reviews-slider');

//         function initSlider() {
//             if (!$slider.hasClass('slick-initialized')) {
//                 $slider.slick({
//                     slidesToShow: 3,
//                     slidesToScroll: 1,
//                     arrows: false,
//                     dots: true,
//                     infinite: true,
//                     autoplay: true,
//                     autoplaySpeed: 5000,
//                     speed: 500,
//                     cssEase: 'ease',
//                     centerMode: false,
//                     variableWidth: true,
//                     pauseOnHover: false,
//                     pauseOnFocus: false,
//                     responsive: [
//                         {
//                             breakpoint: 1199,
//                             settings: {
//                                 slidesToShow: 2
//                             }
//                         }
//                     ]
//                 });
//             }
//         }

//         function destroySlider() {
//             if ($slider.hasClass('slick-initialized')) {
//                 $slider.slick('unslick');

//                 // Remove slick-added classes and inline styles
//                 $slider.find('.slick-slide').removeClass('slick-slide slick-active slick-current');
//                 $slider.find('.slick-track').removeAttr('style');
//                 $slider.find('.slick-slide').removeAttr('style');
//             }
//         }

//         function handleSlider() {
//             if (window.innerWidth <= 767) {
//                 destroySlider(); // destroy on mobile
//             } else {
//                 initSlider(); // initialize on desktop/tablet
//             }
//         }

//         // Run on load
//         handleSlider();

//         // Re-run on resize
//         let resizeTimeout;
//         jQuery(window).on('resize', function () {
//             clearTimeout(resizeTimeout);
//             resizeTimeout = setTimeout(handleSlider, 200);
//         });

//         // Also check if slider was already initialized before DOMContentLoaded
//         if ($slider.hasClass('slick-initialized') && window.innerWidth <= 767) {
//             destroySlider();
//         }
//     }
// });
document.addEventListener('DOMContentLoaded', function () {
    if (typeof jQuery !== 'undefined' && jQuery.fn.slick) {

        const $slider = jQuery('.reviews-slider');

        if (!$slider.hasClass('slick-initialized')) {
            $slider.slick({
                slidesToShow: 3,
                slidesToScroll: 1,
                arrows: false,
                dots: false,
                infinite: true,
                autoplay: true,
                autoplaySpeed: 0,
                speed: 4000, 
                cssEase: 'linear',
                centerMode: false,
                variableWidth: true,
                pauseOnHover: true,
                pauseOnFocus: true,
                responsive: [
                    {
                        breakpoint: 1199,
                        settings: {
                            slidesToShow: 2
                        }
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 1,
                            variableWidth: false,
                            speed: 5000,
                        }
                    }
                ]
            });
        }

    }
});

// if ($slider.hasClass('slick-initialized') && window.innerWidth <= 767) {
//     destroySlider();
// }


// faq js start
document.querySelectorAll('.faq-question').forEach(button => {
    button.addEventListener('click', () => {
        const currentItem = button.parentElement;
        const currentAnswer = currentItem.querySelector('.faq-answer');

        // Close all other FAQs
        document.querySelectorAll('.faq-item').forEach(item => {
            if (item !== currentItem) {
                item.classList.remove('active');
                const answer = item.querySelector('.faq-answer');
                if (answer) answer.style.display = 'none';
            }
        });

        // Toggle current FAQ
        const isActive = currentItem.classList.contains('active');
        currentItem.classList.toggle('active', !isActive);
        currentAnswer.style.display = !isActive ? 'block' : 'none';
    });
});

// faq js end

// product media prev next image js start
document.addEventListener("DOMContentLoaded", function () {
  const slider = document.querySelector('[id^="Slider-Gallery"]');
  if (!slider) return;

  const prevBtn = document.querySelector(".media-arrow--prev");
  const nextBtn = document.querySelector(".media-arrow--next");
  const slides = slider.querySelectorAll(".product__media-item");
  
  if (!slides.length || !prevBtn || !nextBtn) return;

  // Update buttons state
  function updateButtons(index) {
    prevBtn.disabled = index === 0;
    nextBtn.disabled = index === slides.length - 1;
  }

  let currentIndex = Array.from(slides).findIndex(slide =>
    slide.classList.contains("is-active")
  );
  if (currentIndex === -1) currentIndex = 0;
  updateButtons(currentIndex);

  document.body.addEventListener("click", function (e) {
    if (e.target.closest(".media-arrow--prev")) {
      if (currentIndex > 0) {
        currentIndex--;
      }
    } else if (e.target.closest(".media-arrow--next")) {
      if (currentIndex < slides.length - 1) {
        currentIndex++;
      }
    } else {
      return;
    }

    slides.forEach(slide => slide.classList.remove("is-active"));
    slides[currentIndex].classList.add("is-active");

    slider.scrollTo({
      left: slides[currentIndex].offsetLeft - slider.offsetLeft,
      behavior: "smooth"
    });

    updateButtons(currentIndex);
  });
});
// product media prev next image js end

// faq search js start
document.addEventListener("DOMContentLoaded", function () {
  const searchInput = document.getElementById("faqSearch");
  const items = document.querySelectorAll(".faq-right .faq-item");

  if (!searchInput || !items.length) return;

  searchInput.addEventListener("input", function () {
    const value = this.value.toLowerCase().trim();

    items.forEach(item => {
      const questionEl = item.querySelector(".faq-question");
      const answerEl = item.querySelector(".faq-answer");

      const questionText = (questionEl?.textContent || "")
        .toLowerCase()
        .replace(/\s+/g, " ")
        .trim();

      const answerText = (answerEl?.textContent || "")
        .toLowerCase()
        .replace(/\s+/g, " ")
        .trim();

      const matchQuestion = questionText.includes(value);
      const matchAnswer = answerText.includes(value);

      // Show item if either matches
      if (matchQuestion || matchAnswer) {
        item.style.display = "";

        // 👉 ONLY expand if match is in ANSWER
        if (answerEl) {
          if (matchAnswer && value !== "") {
            answerEl.style.display = "block";
            item.classList.add("active");
          } else {
            answerEl.style.display = "";
            item.classList.remove("active");
          }
        }
      } else {
        item.style.display = "none";

        // reset state when hidden
        if (answerEl) {
          answerEl.style.display = "";
          item.classList.remove("active");
        }
      }
    });
  });
});
// faq search js end








